export const isObjectEmpty = (objectName) => {
  if (!objectName) return true
  return (
    Object.keys(objectName).length === 0 && objectName.constructor === Object
  )
}
